export default "__VITE_ASSET__Bc1DI5KI__"